import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { ITextareaInputProps } from './index'

type C = React.ComponentType<ITextareaInputProps>

function withRedux(Component: C) {
  return function({
                    input,
                    meta,
                    ...rest
                  }: WrappedFieldProps & ITextareaInputProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        errorMsg={meta.error}
        warningMsg={meta.warning}
        isSelected={meta.active}
        isValidating={meta.asyncValidating}
        {...rest}
      />
    )
  }
}

export default withRedux
